import { Component, HostListener, ViewChild } from '@angular/core';
import { VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import { WizBasePopUp, WizDatasource, WizIcon, WizList, WizRoot, WizEventManager } from '@wizeoo/akm-component-lib';
import { ConnectItemRenderer } from './connect-item-renderer';
import { ConnectVO } from '../../../vo/core/connect.vo';
import { AlkEvent } from '../../../framework/events/alk.event';
import { ALK_EVENT_TYPE, CONNECT_RETURN_ACTION } from '../../../model/enums';

export interface ConnectItem {
  message: string,
  icon: any
}

/**
 * rendu de la pop de confirmation
 */
@Component({
  selector: 'connect-return-renderer',
  templateUrl: './connect-return-renderer.html'
})
export class ConnectReturnRenderer extends WizBasePopUp {

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  @ViewChild('lstData', { read: WizList }) lstData: WizList; // liste des champs de donnée
  public title: string = '$.call.success.$'; // Description de l'élément
  public messDS: WizDatasource<ConnectItem> = new WizDatasource<ConnectItem>().setSelectionMode('none').build();
  public renderer: any = ConnectItemRenderer;

  public show(): void {

    // Lorsqu'on vient d'un appel synchrone, les données fournies correspondent à la commande exécutée
    // alors que lorsqu'on vient d'un appel asynchrone, les données fournies proviennent du message WebSocket, c'est à dire un tableau fournissant la fonction connect et le résultat
    let cnx: ConnectVO = this.datas.cnx;
    let infos: any = this.datas.result;
    if (!cnx) {
      cnx = this.datas[0];
      infos = this.datas[1];
    }

    this.title = cnx.trsResultSuccess || '$.call.success.$';
    let messArr: ConnectItem[] = [];

    try {
      if (infos.externalMessages) {
        infos.externalMessages.forEach((m: any) => {
          messArr.push({ message: m.message, icon: WizIcon.TOAST_SUCCESS });
        });
      }
      if (infos.warnings) {
        infos.warnings.forEach((m: any) => {
          messArr.push({ message: m.message, icon: WizIcon.TOAST_WARNING });
        });
      }


    } catch (e: any) {

    }

    this.messDS.setSource(messArr);

  }

  public doHide(): void {
    this.hide();
  }

  public onHide(): void {
    /** fin de popUp ou de  */
    // Lorsqu'on vient d'un appel synchrone, les données fournies correspondent à la commande exécutée
    // alors que lorsqu'on vient d'un appel asynchrone, les données fournies proviennent du message WebSocket, c'est à dire un tableau fournissant la fonction connect et le résultat
    let cnx: ConnectVO = this.datas.cnx;
    if (!cnx) {
      cnx = this.datas[0];
    }
    if (cnx.resultAction === CONNECT_RETURN_ACTION.POP) {
      // dispatch pour forcer le reload
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.COMPOSITE_RELOAD, cnx)); // on le signale
    }
  }

}
